import { useMemo, useCallback } from 'react'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import { baseURL } from '@/v2/constants/requests'

const EMPTY_OBJECT = {}
const EMPTY_ARRAY = []

export const useClinic = () => {
  const queryClient = useQueryClient()
  const { data, isLoading, isError } = useQuery({
    queryKey: ['Clinic'],
    queryFn: async () => {
      const res = await fetch(`${baseURL}/v2/rest/clinics.json`)
      if (!res.ok) {
        throw new Error(`Error fetching clinic: ${res.statusText}`)
      }
      return res.json()
    },
  })

  const clinic = data
  const types = clinic?.appointmentTypes ?? EMPTY_OBJECT
  const rooms = clinic?.rooms ?? EMPTY_ARRAY
  const doctors = clinic?.doctors ?? EMPTY_ARRAY

  const refetch = useCallback(() => {
    queryClient.invalidateQueries({ queryKey: ['Clinic'] })
  }, [queryClient])

  return {
    loading: isLoading,
    error: isError,
    clinic,
    rooms,
    doctors,
    types,
    refetch,
  }
}
